import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export default async function UserDetailService() {
  const res = await api.get(routes.GET_USER_DETAILS);
  return res;
}
